import { AppPlatform } from "app/types";
import { PlanType } from "features/subscription";
import { PlanCategory } from "features/subscription/useNativePackages";

// プランカラー
export const PLAN_CATEGORY_COLORS: Record<PlanCategory, string> = {
  standard: "#66BB6A",
  premium: "#FF5722",
};

// プラン別の背景色（PlanBadgeと統一）
export const getPlanColor = (planType: PlanType): string => {
  switch (planType) {
    case PlanType.TRIAL:
      return "#9E9E9E";
    case PlanType.FREE:
      return "#4C9DF1";
    case PlanType.STANDARD:
      return "#66BB6A";
    case PlanType.PREMIUM:
      return "#FF5722";
    case PlanType.BUILDER:
      return "#9C27B0";
    case PlanType.EDUCATION:
      return "#3E5878";
    default:
      return "#9E9E9E";
  }
};

export const getPaymentProvider = (platform: string | undefined): string => {
  switch (platform) {
    case AppPlatform.iOS:
      return "app_store";
    case AppPlatform.Android:
      return "play_store";
    default:
      return "stripe";
  }
};
